import { makeAutoObservable } from "mobx";
import { ROUTE_AUTOMATION_LIST } from "../utils/constants";

const DEFAULT_PATH = {
  name: ROUTE_AUTOMATION_LIST,
  data: {},
};

export class RouterStore {
  constructor() {
    makeAutoObservable(this);
  }

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  path: { name: string; data: { [key: string]: any } } = DEFAULT_PATH;

  resetPath(): void {
    this.path = DEFAULT_PATH;
  }

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  setPath(name: string, data?: { [key: string]: any }): void {
    this.path = {
      name,
      data: data ?? {},
    };
  }
}
